const PRODUCTS = {
  productattribute: 'Produktattribut|Produktattribute',
  productgroup: 'Produktgruppe|Produktgruppen',
  product: 'Produkt|Produkte',
};

export default PRODUCTS;
